import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 4 — Capitulo III · Prohibiciones (lista dinamica desde config.prohibiciones)

// SVG X reutilizable para cada item de la grilla .prohib
const IconX = () => (
  <svg viewBox="0 0 24 24">
    <line x1="6"  y1="6"  x2="18" y2="18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <line x1="18" y1="6"  x2="6"  y2="18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default function ProhibicionesPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const secNum = String(pagNum - 2).padStart(2, "0");
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Prohibiciones</span>
        <h2 className="big">Lo que no se <em>puede hacer.</em></h2>

        <div className="art">
          <div className="art-head">
            <div className="art-num">Capítulo {capRomanoMap.prohibiciones}</div>
            <h3 className="art-title">Prohibiciones</h3>
          </div>
          <p className="art-lede">
            Está prohibido a copropietarios, arrendatarios, ocupantes, proveedores y operarios:
          </p>
          <ul className="prohib">
            {config.prohibiciones.map((p) => (
              <li key={p.id}>
                <span className="x"><IconX /></span>
                <span>{renderConBold(p.texto)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}

// Helper: convierte texto con **negrita** a JSX con <b>negrita</b>. Soporta multiples segmentos.
function renderConBold(texto) {
  if (!texto || !texto.includes("**")) return texto;
  const partes = texto.split(/\*\*(.+?)\*\*/g);
  return partes.map((seg, i) => (i % 2 === 1 ? <b key={i}>{seg}</b> : seg));
}
